export const QN_VIDEO_COUNT_PER_PAGE = 5;
export const RECOMMENDED_COUNT_PER_PAGE = 20;
export const QN_ARTICLE_COUNT_PER_PAGE = 5;

export const ENDCARD_FEED_MSG =
  "Anda telah mengikuti perkembangan berita terkini bagi hari ini.";
export const ENDCARD_VIDEO_MSG = "Anda telah mengikuti video terkini.";
export const QN_SOCIAL_ICON_LIST = [
  "facebook",
  "telegram",
  "plainWhatsapp",
  "newsPost",
];

export const CAROUSEL_TRANSITION_DURATION = "0.8s";
export const CAROUSEL_TRANSITION_EASING =
  "cubic-bezier(0.175, 0.885, 0.32, 1.275)";

export const SIZE_THRESHOLD_SMALL = 50;
export const SIZE_THRESHOLD_MEDIUM = 100;

export const ADDITION_SMALL = 30;
export const ADDITION_MEDIUM = 20;
export const ADDITION_LARGE = 10;
